const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgComputerTrust = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 932 706",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,682.097c0,-1.3 1.053,-2.353 2.352,-2.353l735.92,-0c1.3,-0 2.353,1.053 2.353,2.353c0,12.991 -10.531,23.522 -23.522,23.522l-693.58,-0c-12.991,-0 -23.523,-10.531 -23.523,-23.522Z",
    style: {
      fill: "#eaeaea",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.238,243.094c-16.75,-0 -30.327,13.578 -30.327,30.327l-0,408.323l656.239,-0l-0,-408.323c-0,-16.749 -13.578,-30.327 -30.325,-30.327l-595.588,-0Zm-8.053,20.221c-1.97,0 -3.567,1.598 -3.567,3.568l-0,391.07c-0,1.972 1.597,3.569 3.567,3.569l611.694,0c1.972,0 3.569,-1.597 3.569,-3.569l-0,-391.07c-0,-1.97 -1.597,-3.568 -3.569,-3.568l-611.694,0Z",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.611,266.883c0,-1.971 1.598,-3.568 3.568,-3.568l611.696,-0c1.969,-0 3.566,1.597 3.566,3.568l-0,391.07c-0,1.969 -1.597,3.569 -3.566,3.569l-611.696,0c-1.97,0 -3.568,-1.6 -3.568,-3.569l0,-391.07Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320.887,336.424c-0,-2.419 -1.965,-4.384 -4.384,-4.384l-96.573,0c-2.42,0 -4.384,1.965 -4.384,4.384l-0,5.788c-0,2.419 1.964,4.383 4.384,4.383l96.573,0c2.419,0 4.384,-1.964 4.384,-4.383l-0,-5.788Z",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.195,357.448c0,-2.42 -1.964,-4.384 -4.384,-4.384l-73.884,-0c-2.42,-0 -4.384,1.964 -4.384,4.384l0,5.787c0,2.42 1.964,4.384 4.384,4.384l73.884,-0c2.42,-0 4.384,-1.964 4.384,-4.384l0,-5.787Z",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.218,401.662c-0,-1.837 -1.491,-3.328 -3.328,-3.328l-421.872,-0c-1.837,-0 -3.328,1.491 -3.328,3.328l-0,38.622c-0,1.837 1.491,3.328 3.328,3.328l421.872,0c1.837,0 3.328,-1.491 3.328,-3.328l-0,-38.622Z",
    style: {
      fill: "#5d6d98",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.627,411.27l428.861,0l-0,51.336c-0,3.174 -2.576,5.748 -5.75,5.748l-417.364,-0c-3.174,-0 -5.747,-2.574 -5.747,-5.748l-0,-51.336Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.274,424.546c0,-2.115 -1.717,-3.832 -3.831,-3.832l-32.272,-0c-2.115,-0 -3.832,1.717 -3.832,3.832l0,32.271c0,2.115 1.717,3.832 3.832,3.832l32.272,0c2.114,0 3.831,-1.717 3.831,-3.832l0,-32.271Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.393,435.471c-0,-2.115 -1.717,-3.832 -3.832,-3.832l-91.964,0c-2.114,0 -3.831,1.717 -3.831,3.832l-0,6.706c-0,2.114 1.717,3.831 3.831,3.831l91.964,0c2.115,0 3.832,-1.717 3.832,-3.831l-0,-6.706Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.351,449.133c0,-2.114 -1.717,-3.831 -3.832,-3.831l-92.921,-0c-2.114,-0 -3.831,1.717 -3.831,3.831l-0,3.832c-0,2.115 1.717,3.832 3.831,3.832l92.921,0c2.115,0 3.832,-1.717 3.832,-3.832l0,-3.832Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.459,429.018c0,-2.115 -1.717,-3.832 -3.832,-3.832l-136.029,0c-2.114,0 -3.831,1.717 -3.831,3.832l-0,6.706c-0,2.114 1.717,3.831 3.831,3.831l136.029,0c2.115,0 3.832,-1.717 3.832,-3.831l0,-6.706Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M645.486,497.348c-0,-3.172 -2.576,-5.748 -5.748,-5.748l-417.364,0c-3.172,0 -5.747,2.576 -5.747,5.748l-0,45.588c-0,3.172 2.575,5.748 5.747,5.748l417.364,-0c3.172,-0 5.748,-2.576 5.748,-5.748l-0,-45.588Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.274,504.877c0,-2.115 -1.717,-3.832 -3.831,-3.832l-32.272,0c-2.115,0 -3.832,1.717 -3.832,3.832l0,32.272c0,2.114 1.717,3.831 3.832,3.831l32.272,0c2.114,0 3.831,-1.717 3.831,-3.831l0,-32.272Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.393,515.801c-0,-2.115 -1.717,-3.832 -3.832,-3.832l-91.964,-0c-2.114,-0 -3.831,1.717 -3.831,3.832l-0,6.705c-0,2.115 1.717,3.832 3.831,3.832l91.964,0c2.115,0 3.832,-1.717 3.832,-3.832l-0,-6.705Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.351,529.463c0,-2.114 -1.717,-3.831 -3.832,-3.831l-92.921,-0c-2.114,-0 -3.831,1.717 -3.831,3.831l-0,3.832c-0,2.115 1.717,3.832 3.831,3.832l92.921,0c2.115,0 3.832,-1.717 3.832,-3.832l0,-3.832Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.459,509.348c0,-2.115 -1.717,-3.832 -3.832,-3.832l-136.029,0c-2.114,0 -3.831,1.717 -3.831,3.832l-0,6.706c-0,2.114 1.717,3.831 3.831,3.831l136.029,0c2.115,0 3.832,-1.717 3.832,-3.831l0,-6.706Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M645.486,574.967c-0,-3.173 -2.576,-5.748 -5.748,-5.748l-417.364,-0c-3.172,-0 -5.747,2.575 -5.747,5.748l-0,45.588c-0,3.172 2.575,5.748 5.747,5.748l417.364,-0c3.172,-0 5.748,-2.576 5.748,-5.748l-0,-45.588Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.274,582.498c0,-2.115 -1.717,-3.832 -3.831,-3.832l-32.272,-0c-2.115,-0 -3.832,1.717 -3.832,3.832l0,32.271c0,2.115 1.717,3.832 3.832,3.832l32.272,0c2.114,0 3.831,-1.717 3.831,-3.832l0,-32.271Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.393,593.419c-0,-2.114 -1.717,-3.831 -3.832,-3.831l-91.964,-0c-2.114,-0 -3.831,1.717 -3.831,3.831l-0,6.706c-0,2.115 1.717,3.832 3.831,3.832l91.964,-0c2.115,-0 3.832,-1.717 3.832,-3.832l-0,-6.706Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.351,607.082c0,-2.115 -1.717,-3.832 -3.832,-3.832l-92.921,0c-2.114,0 -3.831,1.717 -3.831,3.832l-0,3.832c-0,2.115 1.717,3.832 3.831,3.832l92.921,-0c2.115,-0 3.832,-1.717 3.832,-3.832l0,-3.832Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.459,586.966c0,-2.115 -1.717,-3.831 -3.832,-3.831l-136.029,-0c-2.114,-0 -3.831,1.716 -3.831,3.831l-0,6.706c-0,2.115 1.717,3.832 3.831,3.832l136.029,-0c2.115,-0 3.832,-1.717 3.832,-3.832l0,-6.706Z",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.585,
    y: 262.5,
    width: 119.926,
    height: 399.453,
    style: {
      fill: "#0c193b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.512,
    y: 262.5,
    width: 499.153,
    height: 33.962,
    style: {
      fill: "#f9f9f9"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.652,
    cy: 323.955,
    rx: 4.862,
    ry: 4.852,
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.304,323.486c0,-2.419 -1.964,-4.383 -4.383,-4.383l-57.678,-0c-2.42,-0 -4.384,1.964 -4.384,4.383l-0,0.937c-0,2.42 1.964,4.384 4.384,4.384l57.678,0c2.419,0 4.383,-1.964 4.383,-4.384l0,-0.937Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.653,
    cy: 353.069,
    rx: 4.862,
    ry: 4.852,
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.304,352.597c-0,-2.419 -1.965,-4.384 -4.384,-4.384l-57.678,0c-2.42,0 -4.384,1.965 -4.384,4.384l0,0.937c0,2.419 1.964,4.384 4.384,4.384l57.678,-0c2.419,-0 4.384,-1.965 4.384,-4.384l-0,-0.937Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.653,
    cy: 382.175,
    rx: 4.862,
    ry: 4.852,
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.304,381.705c-0,-2.42 -1.965,-4.384 -4.384,-4.384l-57.678,-0c-2.42,-0 -4.384,1.964 -4.384,4.384l0,0.936c0,2.42 1.964,4.384 4.384,4.384l57.678,0c2.419,0 4.384,-1.964 4.384,-4.384l-0,-0.936Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.653,
    cy: 411.285,
    rx: 4.862,
    ry: 4.852,
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.304,410.816c-0,-2.42 -1.965,-4.384 -4.384,-4.384l-57.678,-0c-2.42,-0 -4.384,1.964 -4.384,4.384l0,0.936c0,2.42 1.964,4.384 4.384,4.384l57.678,0c2.419,0 4.384,-1.964 4.384,-4.384l-0,-0.936Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.653,
    cy: 440.395,
    rx: 4.862,
    ry: 4.852,
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.304,439.926c-0,-2.419 -1.965,-4.384 -4.384,-4.384l-57.678,0c-2.42,0 -4.384,1.965 -4.384,4.384l0,0.937c0,2.42 1.964,4.384 4.384,4.384l57.678,-0c2.419,-0 4.384,-1.964 4.384,-4.384l-0,-0.937Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.063,282.553c-0.747,-0.415 -1.617,-0.623 -2.573,-0.623c-0.991,0 -1.886,0.217 -2.651,0.64c-0.764,0.433 -1.373,1.047 -1.799,1.834c-0.243,0.449 -0.417,0.951 -0.521,1.496c-0.009,0.025 -0,0.051 0.026,0.077c0.017,0.018 0.043,0.026 0.078,0.026c0.556,-0.069 1.234,-0.103 2.129,-0.103c0.044,-0 0.079,-0.026 0.087,-0.07c0.139,-0.545 0.409,-1.003 0.791,-1.34c0.487,-0.432 1.087,-0.657 1.782,-0.657c0.765,-0 1.408,0.225 1.921,0.666c0.487,0.423 0.756,0.986 0.782,1.677l-4.424,0c-3.685,-0.052 -5.302,0.199 -6.397,2.966c-0.452,0.899 -1.199,1.34 -2.286,1.34c-0.747,0 -1.39,-0.233 -1.903,-0.7c-0.496,-0.45 -0.782,-1.038 -0.852,-1.764l5.05,-0c0.035,-0 0.061,-0.017 0.078,-0.043c0.582,-1.012 1.312,-1.557 2.46,-1.825c0.043,-0.008 0.069,-0.052 0.069,-0.095c-0.087,-0.64 -0.278,-1.219 -0.565,-1.729c-0.417,-0.752 -1.008,-1.349 -1.764,-1.764c-0.748,-0.415 -1.617,-0.623 -2.573,-0.623c-0.99,0 -1.886,0.216 -2.65,0.64c-0.765,0.432 -1.374,1.046 -1.8,1.833c-0.425,0.787 -0.634,1.712 -0.634,2.741c-0,1.038 0.217,1.963 0.652,2.75c0.434,0.787 1.043,1.41 1.816,1.842c0.765,0.432 1.651,0.657 2.616,0.657c1.191,0 2.199,-0.302 3.008,-0.891c0.782,-0.579 1.338,-1.322 1.651,-2.222l-0,-0.009c0.009,-0.008 0.009,-0.017 0.017,-0.034c0.487,-1.262 1.417,-1.245 2.825,-1.219c0.348,0.008 0.713,0.008 1.104,-0l6.684,-0c0.043,-0 0.078,-0.035 0.087,-0.069c0.052,-0.303 0.069,-0.649 0.069,-1.029c0,-0.978 -0.208,-1.851 -0.625,-2.603c-0.426,-0.77 -1.018,-1.358 -1.765,-1.773Zm-14.932,1.937c0.487,-0.432 1.087,-0.657 1.782,-0.657c0.765,-0 1.408,0.225 1.92,0.666c0.487,0.423 0.757,0.986 0.783,1.677l-5.354,0c0.113,-0.7 0.4,-1.271 0.869,-1.686Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.088,289.09l-2.234,-0c-0.034,-0 -0.06,0.017 -0.078,0.051c-0.452,0.909 -1.199,1.341 -2.286,1.341c-0.747,-0 -1.39,-0.234 -1.903,-0.701c-0.417,-0.371 -0.687,-0.864 -0.799,-1.444c-0.009,-0.043 -0.044,-0.069 -0.088,-0.069l-0.199,0c-0.704,-0.008 -1.322,-0.026 -1.817,0.138c0,0 -0.009,0 -0.009,0.009c-0.008,0 -0.017,0.009 -0.026,0.009c-0.017,0.008 -0.035,0.017 -0.052,0.026c-0.035,0.017 -0.043,0.052 -0.035,0.095c0.105,0.501 0.261,0.916 0.505,1.357c0.434,0.787 1.042,1.41 1.816,1.842c0.765,0.433 1.643,0.657 2.616,0.657c1.191,0 2.199,-0.302 3.007,-0.89c0.809,-0.597 1.365,-1.366 1.678,-2.292c0.008,-0.026 -0,-0.052 -0.009,-0.078c-0.026,-0.043 -0.052,-0.052 -0.087,-0.052Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.908,287.758c-0.347,-0.398 -0.765,-0.7 -1.243,-0.899c-0.469,-0.199 -1.077,-0.398 -1.799,-0.588c-0.538,-0.156 -0.956,-0.286 -1.234,-0.389c-0.269,-0.095 -0.495,-0.234 -0.678,-0.407c-0.174,-0.164 -0.261,-0.363 -0.261,-0.605c0,-0.311 0.131,-0.553 0.4,-0.744c0.278,-0.19 0.678,-0.294 1.208,-0.294c0.531,0 0.965,0.13 1.269,0.381c0.313,0.251 0.478,0.579 0.513,1.003c0,0.043 0.044,0.078 0.087,0.078l2.069,-0c0.026,-0 0.043,-0.009 0.06,-0.026c0.018,-0.018 0.027,-0.043 0.027,-0.061c-0.053,-1.012 -0.435,-1.816 -1.148,-2.404c-0.712,-0.579 -1.651,-0.882 -2.807,-0.882c-0.774,0 -1.469,0.13 -2.06,0.389c-0.6,0.26 -1.069,0.615 -1.391,1.073c-0.321,0.449 -0.486,0.96 -0.486,1.504c-0,0.666 0.182,1.22 0.538,1.635c0.357,0.406 0.774,0.709 1.261,0.908c0.478,0.19 1.095,0.397 1.842,0.596c0.765,0.216 1.33,0.415 1.687,0.588c0.33,0.165 0.486,0.415 0.486,0.752c0,0.32 -0.147,0.58 -0.443,0.787c-0.304,0.208 -0.748,0.32 -1.304,0.32c-0.26,0 -0.504,-0.034 -0.73,-0.095l-0.009,0c-0.347,-0.095 -0.521,-0.052 -0.643,0.164c-0.512,0.865 -1.086,1.012 -1.138,1.029c-0.035,0 -0.07,0.026 -0.079,0.061c-0.008,0.035 0.009,0.078 0.044,0.095c0.139,0.087 0.287,0.164 0.443,0.233c0.635,0.286 1.356,0.433 2.156,0.433c0.782,-0 1.477,-0.13 2.06,-0.389c0.591,-0.259 1.051,-0.623 1.373,-1.081c0.321,-0.458 0.487,-0.986 0.487,-1.574c-0.027,-0.657 -0.209,-1.193 -0.557,-1.591Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.484,291.243c0.591,-0 1.069,-0.476 1.069,-1.063c0,-0.588 -0.478,-1.064 -1.069,-1.064c-0.59,0 -1.069,0.476 -1.069,1.064c0,0.587 0.479,1.063 1.069,1.063Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458,278.671l-2.095,0c-0.052,0 -0.087,0.035 -0.087,0.087l-0,4.573c-0.365,-0.397 -0.834,-0.726 -1.399,-0.976c-0.644,-0.286 -1.313,-0.433 -1.973,-0.433c-0.896,0 -1.721,0.216 -2.451,0.657c-0.731,0.432 -1.321,1.055 -1.739,1.833c-0.426,0.778 -0.634,1.686 -0.634,2.698c0,1.011 0.217,1.928 0.634,2.723c0.426,0.804 1.008,1.435 1.739,1.876c0.73,0.45 1.547,0.675 2.433,0.675c0.782,-0 1.495,-0.164 2.104,-0.484c0.521,-0.277 0.947,-0.614 1.277,-1.012l0,1.245c0,0.052 0.035,0.087 0.087,0.087l2.095,-0c0.052,-0 0.087,-0.035 0.087,-0.087l-0,-13.375c0.008,-0.052 -0.035,-0.087 -0.079,-0.087Zm-2.181,8.473c-0,0.666 -0.139,1.263 -0.417,1.756c-0.278,0.492 -0.643,0.881 -1.087,1.132c-0.443,0.259 -0.93,0.389 -1.451,0.389c-0.504,0 -0.991,-0.13 -1.434,-0.398c-0.452,-0.259 -0.817,-0.648 -1.095,-1.149c-0.279,-0.502 -0.418,-1.099 -0.418,-1.764c0,-0.666 0.139,-1.254 0.418,-1.738c0.278,-0.484 0.643,-0.856 1.086,-1.107c0.443,-0.25 0.93,-0.38 1.452,-0.38c0.512,-0 0.999,0.13 1.451,0.389c0.443,0.259 0.808,0.631 1.086,1.124c0.27,0.493 0.409,1.081 0.409,1.746Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,291.347c-0.035,-0.008 -0.504,-0.198 -0.626,-1.15c-0.017,-0.121 -0.104,-0.285 -0.252,-0.354c-0.087,-0.035 -0.217,-0.052 -0.382,0.069c-0.435,0.372 -1,0.562 -1.695,0.562c-0.748,0 -1.391,-0.233 -1.904,-0.7c-0.417,-0.372 -0.686,-0.865 -0.799,-1.445c-0.009,-0.043 -0.044,-0.069 -0.087,-0.069l-0.2,0c-0.704,-0.008 -1.321,-0.026 -1.817,0.139c0,-0 -0.008,-0 -0.008,0.008c-0.009,0 -0.018,0.009 -0.027,0.009c-0.017,0.009 -0.034,0.018 -0.051,0.026c-0.035,0.017 -0.044,0.052 -0.035,0.095c0.104,0.502 0.26,0.917 0.504,1.358c0.434,0.787 1.043,1.409 1.816,1.842c0.765,0.432 1.643,0.657 2.616,0.657c1.183,-0 2.191,-0.294 2.99,-0.882c0.026,-0.018 0.044,-0.052 0.035,-0.087c-0.017,-0.043 -0.043,-0.069 -0.078,-0.078Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,288.01c0.348,0.009 0.713,0.009 1.103,-0l6.684,-0c0.044,-0 0.079,-0.035 0.087,-0.069c0.052,-0.303 0.07,-0.649 0.07,-1.029c-0,-0.977 -0.209,-1.851 -0.626,-2.603c-0.417,-0.752 -1.008,-1.349 -1.765,-1.764c-0.747,-0.415 -1.616,-0.623 -2.572,-0.623c-0.991,0 -1.886,0.217 -2.651,0.64c-0.765,0.433 -1.373,1.047 -1.799,1.833c-0.243,0.45 -0.417,0.952 -0.522,1.496c-0.008,0.026 0,0.052 0.026,0.078c0.018,0.017 0.044,0.026 0.079,0.026c0.556,-0.069 1.234,-0.104 2.129,-0.104c0.044,0 0.078,-0.026 0.087,-0.069c0.139,-0.545 0.408,-1.003 0.791,-1.34c0.487,-0.432 1.086,-0.657 1.782,-0.657c0.764,-0 1.408,0.225 1.92,0.665c0.487,0.424 0.757,0.986 0.783,1.678l-4.424,-0c-3.694,-0.052 -5.311,0.199 -6.406,2.983c-0.4,0.891 -1.13,1.315 -2.216,1.315c-0.817,-0 -1.478,-0.294 -1.964,-0.874c-0.487,-0.588 -0.739,-1.409 -0.739,-2.455c-0,-1.047 0.243,-1.868 0.73,-2.447c0.486,-0.571 1.138,-0.865 1.964,-0.865c0.582,-0 1.078,0.138 1.46,0.398c0.383,0.267 0.67,0.639 0.843,1.115c0.009,0.035 0.044,0.061 0.079,0.061l2.233,-0c0.026,-0 0.052,-0.009 0.07,-0.035c0.017,-0.017 0.026,-0.052 0.017,-0.078c-0.287,-1.072 -0.834,-1.92 -1.642,-2.499c-0.809,-0.579 -1.834,-0.873 -3.06,-0.873c-0.965,-0 -1.843,0.216 -2.59,0.648c-0.748,0.433 -1.347,1.047 -1.773,1.833c-0.426,0.787 -0.635,1.713 -0.635,2.742c0,1.037 0.218,1.954 0.635,2.741c0.426,0.786 1.017,1.409 1.773,1.841c0.747,0.433 1.617,0.658 2.59,0.658c1.2,-0 2.225,-0.312 3.033,-0.917c0.791,-0.588 1.348,-1.392 1.643,-2.395c0.513,-1.09 1.417,-1.072 2.773,-1.055Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.202,281.922c-0.704,0 -1.322,0.147 -1.835,0.433c-0.425,0.242 -0.79,0.57 -1.077,0.968l-0,-1.15c-0,-0.052 -0.035,-0.087 -0.087,-0.087l-5.606,0l-0,-2.394c-0,-0.052 -0.035,-0.087 -0.087,-0.087l-2.095,0c-0.052,0 -0.087,0.035 -0.087,0.087l0,2.394l-1.095,0c-0.052,0 -0.087,0.035 -0.087,0.087l0,1.686c0,0.052 0.035,0.086 0.087,0.086l1.095,0l0,5.43c0,0.994 0.261,1.729 0.774,2.179c0.513,0.449 1.251,0.674 2.199,0.674l1.634,0c0.052,0 0.087,-0.034 0.087,-0.086l-0,-1.721c-0,-0.052 -0.035,-0.086 -0.087,-0.086l-1.269,-0c-0.4,-0 -0.687,-0.078 -0.843,-0.225c-0.156,-0.147 -0.235,-0.398 -0.235,-0.744l0,-5.421l3.442,0l0,8.197c0,0.052 0.035,0.086 0.087,0.086l2.086,0c0.052,0 0.087,-0.034 0.087,-0.086l-0,-5.248c-0,-0.986 0.2,-1.678 0.6,-2.075c0.399,-0.389 0.999,-0.588 1.781,-0.588l0.531,-0c0.052,-0 0.086,-0.035 0.086,-0.087l0,-2.135c0,-0.044 -0.034,-0.087 -0.086,-0.087Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.802,282.086l-2.095,-0c-0.052,-0 -0.087,0.034 -0.087,0.086l-0,1.202c-0.339,-0.38 -0.765,-0.718 -1.278,-0.986c-0.599,-0.311 -1.303,-0.467 -2.103,-0.467c-0.886,0 -1.703,0.217 -2.433,0.658c-0.731,0.432 -1.322,1.055 -1.739,1.833c-0.426,0.778 -0.634,1.686 -0.634,2.697c-0,1.012 0.217,1.929 0.634,2.724c0.426,0.805 1.008,1.436 1.73,1.877c0.721,0.449 1.538,0.674 2.407,0.674c0.783,0 1.495,-0.164 2.113,-0.484c0.53,-0.277 0.964,-0.614 1.312,-1.003l-0,1.237c-0,0.051 0.035,0.086 0.087,0.086l2.094,0c0.053,0 0.087,-0.035 0.087,-0.086l0,-9.962c-0.008,-0.043 -0.052,-0.086 -0.095,-0.086Zm-2.182,5.058c-0,0.666 -0.139,1.263 -0.417,1.755c-0.278,0.493 -0.643,0.882 -1.086,1.133c-0.444,0.26 -0.93,0.389 -1.452,0.389c-0.504,0 -0.991,-0.129 -1.434,-0.397c-0.452,-0.26 -0.817,-0.649 -1.095,-1.15c-0.278,-0.502 -0.417,-1.099 -0.417,-1.765c-0,-0.665 0.139,-1.253 0.417,-1.737c0.278,-0.485 0.643,-0.857 1.086,-1.107c0.444,-0.251 0.93,-0.381 1.452,-0.381c0.513,0 0.999,0.13 1.451,0.389c0.443,0.26 0.808,0.631 1.087,1.125c0.269,0.492 0.408,1.08 0.408,1.746Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.616,291.243c0.591,-0 1.07,-0.476 1.07,-1.063c-0,-0.588 -0.479,-1.064 -1.07,-1.064c-0.59,0 -1.069,0.476 -1.069,1.064c0,0.587 0.479,1.063 1.069,1.063Z",
    style: {
      fill: "#ffb801",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 669.134,
    cy: 262.5,
    r: 262.5,
    style: {
      fill: "url(#_Radial1)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 669.71,
    cy: 262.226,
    rx: 161.562,
    ry: 161.068,
    style: {
      fill: "url(#_Radial2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.856,196.158c-5.689,-0 -10.3,4.611 -10.3,10.3l-0,71.235l0.101,0c-0.068,1.016 -0.101,2.05 -0.101,3.1c-0,37.094 50.734,63.038 65.189,69.676c2.444,1.122 5.16,1.122 7.603,-0c14.456,-6.638 65.189,-32.582 65.189,-69.676c0,-1.05 -0.034,-2.083 -0.106,-3.1l0.106,0l0,-71.235c0,-5.689 -4.609,-10.3 -10.3,-10.3l-117.381,-0Z",
    style: {
      fill: "#253561"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.235,285.114c2.01,-2.01 2.01,-5.274 0,-7.284l-22.583,-22.583c-2.01,-2.01 -5.274,-2.01 -7.283,0l-4.664,4.663c-2.01,2.01 -2.01,5.274 0,7.284l22.584,22.583c2.01,2.01 5.273,2.01 7.283,0l4.663,-4.663Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.502,289.053c2.01,2.01 5.274,2.01 7.284,0l37.517,-37.517c2.01,-2.01 2.01,-5.273 -0,-7.283l-4.663,-4.664c-2.01,-2.01 -5.274,-2.01 -7.284,0l-37.517,37.517c-2.01,2.01 -2.01,5.274 0,7.284l4.663,4.663Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.53034e-13,399.716,-399.716,-1.53034e-13,669.134,262.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ecb301",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ecb301",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.39003e-14,245.262,-246.014,-9.41883e-14,669.71,262.226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ecb301",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ecb301",
      stopOpacity: 0.5
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComputerTrust);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/computer-trust.1b9a38487602c049e620a9dedf05938d.svg";